import {
  PriceTierDiscountUpdateRequestType,
  PriceTierDiscountUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceTierDiscountUpdate = (priceTierDiscountId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceTierDiscountUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-tier-discounts/${priceTierDiscountId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceTierDiscountUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierDiscounts],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PriceTierDiscounts,
          priceTierDiscountId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.VolumeDiscounts],
      });
    },
  });
};
